export default __webpack_public_path__ + "ed26743f0de11ebae044d7b9d19f68f9.png";